import { FC, ReactNode } from 'react'
import { useNavigate } from 'react-router'
import r from 'routes'

import { cn } from '@/lib/utils'

interface SetupMenuProps {
  brandingComplete: boolean
  domainComplete: boolean
}

const SetupMenu: FC<SetupMenuProps> = ({ brandingComplete, domainComplete }) => {
  const navigate = useNavigate()

  return (
    <>
      <div className="px-2 py-1 text-xs font-medium text-muted-foreground">Complete account setup:</div>
      <SetupStep label="Logo & Color" complete={brandingComplete} onClick={() => navigate(r.settings.root)} />
      <SetupStep label="Branded Domain" complete={domainComplete} onClick={() => navigate(r.settings.domain)} />
    </>
  )
}

export default SetupMenu

interface SetupStepProps {
  label: ReactNode
  complete: boolean
  onClick?: () => void
}

const SetupStep: FC<SetupStepProps> = ({ label, complete, onClick }) => {
  return (
    <div
      className={cn(
        'flex items-center px-2 py-1.5 cursor-pointer hover:bg-accent/50 transition-colors rounded-sm text-sm',
        !complete && 'text-red-600'
      )}
      onClick={onClick}
      tabIndex={0}
      role="button"
      aria-disabled={complete}
    >
      <span
        className={cn(
          'inline-flex items-center justify-center w-4 h-4 mr-2 rounded-full border',
          complete ? 'bg-green-600 border-green-600' : 'bg-white-600 border-red-600 border-2'
        )}
        aria-hidden="true"
      >
        {complete && (
          <svg className="w-2.5 h-2.5 text-white" fill="none" stroke="currentColor" strokeWidth={3} viewBox="0 0 16 16">
            <path strokeLinecap="round" strokeLinejoin="round" d="M4 8l3 3 5-5" />
          </svg>
        )}
      </span>
      {label}
    </div>
  )
}
